export default class CharaDescription {
  public hair?: string
  public face?: string
  public body?: string
  public dress?: string
  public hasEar?: boolean

  constructor (initial?: Partial<CharaDescription>) {
    Object.assign(this, initial)
  }
}
